import React, { useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import UserLocationMark from './UserLocationMark';
import EventMarker from './EventMarker';
import styled from 'styled-components';
import MultipleMarkers from './MultipleMarkers';

export default function Map({
    latitude,
    longitude,
    data,
    withUserLocation = false,
    multiples,
    onEventClick,
}) {

    useEffect(() => false, [latitude, longitude, data])

    const defaultProps = {
        center: {
            lat: latitude,
            lng: longitude
        },
        zoom: 13,
        // address: '',
    };

    return (
        // Important! Always set the container height explicitly
        <GoogleMapsContainer>
            <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_GMAPS_KEY }}
                center={defaultProps.center}
                defaultZoom={defaultProps.zoom}
            >

                {
                    withUserLocation && <UserLocationMark lat={latitude} lng={longitude} />
                }

                {
                    data && data.map(el => (
                        <EventMarker
                            key={el.id}
                            lat={el.address.lat}
                            lng={el.address.long}
                            name={el.name}
                            type={el.classification.name}
                            image={el.images && el.images[0]}
                            onMarkerClick={() => onEventClick(el)}
                        />
                    ))
                }

                {
                    multiples && multiples.map((el, index) => {
                        return (
                            <MultipleMarkers
                                key={index}
                                lat={el?.multiples[0].address?.lat}
                                lng={el?.multiples[0].address?.long}
                                data={el?.multiples}
                            />
                        )
                    })

                }
            </GoogleMapReact>
        </GoogleMapsContainer>
    );
}

const GoogleMapsContainer = styled.div`
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
`
